import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'

export const getStaffList = async (params: {
  pageNo: number;
  pageSize: number;
  staffStatusList: string;
  needDepartmentNamePath: boolean;
  keyword?: string;
  departmentId?: number;
  groupId?: number;
  costCenterId?: number;
}) => {
  try {
    const data = await request.get<{ result: any[]; totalCount: number }>(
      `${HOSTS.BASE}/api/entweb/staff/search`,
      { params }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}


export interface IStaffItem {
  /** 姓名 */
  name?: string;
  /** 邮箱 */
  email?: string;
  /** 电话 */
  phone?: string;
  /** 状态 */
  status?: number;
  /** 员工ID */
  staffId?: number;
  /** 员工类别 */
  category?: string;
  /** 员工部门链名称，-分割部门，#分割多个部门 */
  departmentNamePath?: string;
  /** 员工所属部门ID，"0" 表示一级部门（无上级部门） */
  departmentId?: string | number;
  /** 员工编号 */
  employeeNum?: string;
  /** 离职时间 */
  scheduledResignTime?: number;
  /** needDepartmentInfo=true时返回 */
  departments?: {
    /** 部门ID */
    id?: number;
    /** 部门名称 */
    name?: string;
    /** id path */
    path?: string;
    /** 只有在needDepartmentInfo=true且needDepartmentInfo=true时返回 */
    namePath?: string;
    /** 父部门ID */
    parentId?: number;
  }[];
  /** 分组列表 */
  groups?: {
    id: number;
    name: string;
  }[];
  /** 成本中心ID */
  costCenterId?: number;
  /** 成本中心名称（展示用，列表接口返回） */
  costCenterName?: string;
}

export const changeStaffStatus = async (params: {
  staffId: string;
  status: number;
}) => {
  try {
    const data = await request.post<{ result: IStaffItem[]; totalCount: number }>(
      `${HOSTS.BASE}/api/entweb/staff/modify`,
      { ...params }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

export const initAllStaffExport = async () => {
  try {
    const data = await request.get<string>(
      `${HOSTS.BASE}/api/entweb/importExport/staff/export`
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

export const queryExportStatus = async (params: { token: string }) => {
  try {
    const data = await request.get<{
      code: number;
      message: string;
      errorCount: number;
      successCount: number;
      downLoadUrl: string;
    }>(`${HOSTS.BASE}/api/entweb/importExport/queryStatus`, { params })
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

export const getStaffTplt = async () => {
  try {
    const data = await request.get<string>(
      `${HOSTS.BASE}/api/entweb/importExport/downloadTemplate`,
      { params: { templateType: 1 } }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

export const batchUploadStaff = async (params: {
  byteBuffer: File;
  operationType: string;
}) => {
  try {
    const data = await request.post<string>(
      `${HOSTS.BASE}/api/entweb/importExport/importData`,
      { ...params },
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}

export const getStaffUploadStatus = async (params: { token: string }) => {
  try {
    const data = await request.get<string>(
      `${HOSTS.BASE}/api/entweb/importExport/queryStatus`,
      { params }
    )
    return { success: true, data }
  } catch (error) {
    return { success: false, error }
  }
}


export interface IStaffInfo{

  /** 姓名 */
  name: string;

  /** 邮箱 */
  email?: string;

  /** 1：离职，2：在职 */
  status: number;

  /** 员工类别（历史字段，已迁移至 groups） */
  category?: string;

  /** 部门ID（接口返回 string | null，"0" 表示无上级部门/一级部门） */
  departmentId?: string | null;

  /** 部门链（展示用，列表接口返回） */
  departmentNamePath?: string;

  /** 分组ID列表（新字段，替代旧 category） */
  groupIds?: number[];

  staffId:string
  scheduledResignTime?: number;
  employeeNum: string; // 员工ID

  /** 分组列表（展示用，列表接口返回） */
  groups?: { id: number; name: string }[];
  /** 成本中心ID（提交用，单选） */
  costCenterId?: number;
  /** 成本中心名称（展示用，列表接口返回） */
  costCenterName?: string;
}

interface IUpdateStaffInfo extends IStaffInfo{
  staffId: string;
}

export const createStaff = async (params: IStaffInfo) => await request.post(`${HOSTS.BASE}/api/entweb/staff/create`, params)
export const updateStaff = async (params: IUpdateStaffInfo) => await request.post(`${HOSTS.BASE}/api/entweb/staff/update`, params)